import sha256 from "crypto-js/sha256";

const generateRandomPassword = () => {
  const randomValue = Math.random().toString(36).slice(2) + Date.now();
  return sha256(randomValue).toString().slice(5, 25);
};

const randomPassword = generateRandomPassword() as string;

export default randomPassword;
